import { CategoryProcessor } from "./CategoryProcessor";
export class CategoryOneProcessor extends CategoryProcessor {
    getCategory() {
        return 'one';
    }
}
